import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


import zqys from './zqys.vue' //中企
import index from './index.vue'
import zsy_esales from './zsy_esales.vue' //中国石油电子销售平台业务模式设计
import zh_crude from './zh_crude.vue' //中化集团原油电商项目B2B咨询
import sqdz_infor from './sqdz_information.vue' //上汽大众销售公司信息战略规划
import zsy_infostrategy from './zsy_infostrategy.vue'//中国石油非油业务信息战略规划
import win from './win.vue'  //双赢物流
import visa from './visa.vue' //visa
import lenven_num from './lenven_num.vue'

// 创建一个路由器实例
// 创建实例时可以传入配置参数进行定制，为保持简单，这里使用默认配置
var router = new VueRouter()

// 定义路由规则
// 每条路由规则应该映射到一个组件。这里的“组件”可以是一个使用 Vue.extend
// 创建的组件构造函数，也可以是一个组件选项对象。
// 稍后我们会讲解嵌套路由
router.map({
  '/zqys': {
    component: zqys
  },
  '/zsy_esales': {
    component: zsy_esales
  },
  '/zh_crude': {
    component: zh_crude
  },
  '/sqdz_infor': {
    component: sqdz_infor
  },
  '/zsy_infostrategy': {
    component: zsy_infostrategy
  },
  '/win': {
    component: win
  },
  '/visa': {
    component: visa
  },
  '/lenven_num': {
    component: lenven_num
  }

})
//重定向
router.redirect({
  '/': '/zqys',
})

// 现在我们可以启动应用了！
// 路由器会创建一个 App 实例，并且挂载到选择符 #app 匹配的元素上。
window.onload = function(){
  router.start(index, '#app')
}





// WEBPACK FOOTER //
// ./src/components/case/Router/router.js